__turbopack_context__.v({
  "avatar": "video-library-module-scss-module__50VK0a__avatar",
  "avatarFallback": "video-library-module-scss-module__50VK0a__avatarFallback",
  "avatarLink": "video-library-module-scss-module__50VK0a__avatarLink",
  "blogCard": "video-library-module-scss-module__50VK0a__blogCard",
  "blogContent": "video-library-module-scss-module__50VK0a__blogContent",
  "blogDate": "video-library-module-scss-module__50VK0a__blogDate",
  "blogDescription": "video-library-module-scss-module__50VK0a__blogDescription",
  "blogGrid": "video-library-module-scss-module__50VK0a__blogGrid",
  "blogImage": "video-library-module-scss-module__50VK0a__blogImage",
  "blogImageFallback": "video-library-module-scss-module__50VK0a__blogImageFallback",
  "blogMedia": "video-library-module-scss-module__50VK0a__blogMedia",
  "blogStrip": "video-library-module-scss-module__50VK0a__blogStrip",
  "blogTitle": "video-library-module-scss-module__50VK0a__blogTitle",
  "categoryLink": "video-library-module-scss-module__50VK0a__categoryLink",
  "emptyState": "video-library-module-scss-module__50VK0a__emptyState",
  "error": "video-library-module-scss-module__50VK0a__error",
  "filterLabel": "video-library-module-scss-module__50VK0a__filterLabel",
  "filterLink": "video-library-module-scss-module__50VK0a__filterLink",
  "filterList": "video-library-module-scss-module__50VK0a__filterList",
  "filterRail": "video-library-module-scss-module__50VK0a__filterRail",
  "headerBlock": "video-library-module-scss-module__50VK0a__headerBlock",
  "libraryContent": "video-library-module-scss-module__50VK0a__libraryContent",
  "loadMore": "video-library-module-scss-module__50VK0a__loadMore",
  "loadMoreWrap": "video-library-module-scss-module__50VK0a__loadMoreWrap",
  "playControl": "video-library-module-scss-module__50VK0a__playControl",
  "titleRow": "video-library-module-scss-module__50VK0a__titleRow",
  "videoCard": "video-library-module-scss-module__50VK0a__videoCard",
  "videoDescription": "video-library-module-scss-module__50VK0a__videoDescription",
  "videoDetails": "video-library-module-scss-module__50VK0a__videoDetails",
  "videoGrid": "video-library-module-scss-module__50VK0a__videoGrid",
  "videoImage": "video-library-module-scss-module__50VK0a__videoImage",
  "videoImageFallback": "video-library-module-scss-module__50VK0a__videoImageFallback",
  "videoLibraryPage": "video-library-module-scss-module__50VK0a__videoLibraryPage",
  "videoMedia": "video-library-module-scss-module__50VK0a__videoMedia",
  "videoMetaRow": "video-library-module-scss-module__50VK0a__videoMetaRow",
  "videoText": "video-library-module-scss-module__50VK0a__videoText",
  "videoTitle": "video-library-module-scss-module__50VK0a__videoTitle",
});
